
import './App.css';

function NotFound() {
  return (
    <div className="App pagenot">
      <h1>Page Not Found</h1>
    </div>
  );
}

export default NotFound;
